import { useSelector } from 'react-redux';

import { getAccountFromSessionSelector } from '@app/reducers/session';

import AiExtractIcon from '@app/components/icons/ai-extract';
import Button from '@app/components/button';
import { checkAcl } from '@flow/libs/utils/acl';
import { T } from '@app/components/translation';
import EmptyState from '@app/components/empty-state';
import { useImportContractContext } from '@app/contexts/import-contract-props';

import { isStandardImport } from '../utils';
import { modalKey } from '../constants';

import style from './ai-extension-disabled.module.scss';

export const AiExtensionDisabled = () => {
  const { importMethod, isAiImportOptionEnabled } = useImportContractContext();

  const account = useSelector(getAccountFromSessionSelector);

  if (isStandardImport(importMethod) || isAiImportOptionEnabled) {
    return null;
  }

  const hasMarketplaceAccess = checkAcl(account.acl, 'account:admin:extension');

  return (
    <EmptyState
      icon={<AiExtractIcon height="100px" />}
      className={style.EmptyState}
      defaultStyle
      content={
        <>
          <T
            _str="{featureName} is ready. Enable it in Marketplace to start extracting duration and participants automatically."
            _comment="Message showing when a feature is disabled but available to enable at anytime on our Marketplace page"
            featureName="AI Extract"
          />
          {hasMarketplaceAccess ? (
            <Button
              href="/marketplace/ai-extract"
              target="_blank"
              rel="noopener noreferrer"
              kind="link"
              data-test-id="marketplace-link"
              customClass={style.MarketplaceLink}
              trackable={{
                name: 'Go To Marketplace Card',
                props: {
                  location: modalKey,
                  key: 'ai_import',
                },
              }}
            >
              <T
                _str="Enable in Marketplace"
                _comment="Button text to navigate to the Marketplace page"
              />
            </Button>
          ) : (
            <p className={style.NoAdminAccessMessage}>
              <T
                _str="Contact your Oneflow admin for access."
                _comment="Showing when user does not have access to a feature"
              />
            </p>
          )}
        </>
      }
    />
  );
};
